import {
  faCheck,
  faEdit,
  faPlusCircle,
  faTrashCan,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function AbortAction({ handleAction }) {
  return (
    <span
      data-testid="action-abort"
      data-toggle="modal"
      onClick={() => {
        handleAction && handleAction();
      }}
      role={"button"}
    >
      <FontAwesomeIcon
        id="clickableAwesomeFont"
        data-toggle="tooltip"
        title="Cancel"
        color={"red"}
        icon={faXmark}
        className="mx-2"
      />
    </span>
  );
}

export function DeleteAction({ tableItem, handleAction }) {
  return (
    <span
      data-testid="action-delete"
      data-toggle="modal"
      onClick={() => {
        handleAction && handleAction(tableItem);
      }}
      role={"button"}
    >
      <FontAwesomeIcon
        id="clickableAwesomeFont"
        data-toggle="tooltip"
        title="Delete"
        color="red"
        className="mx-2"
        icon={faTrashCan}
      />
    </span>
  );
}

export function EditAction({ tableItem, handleAction }) {
  return (
    <span
      data-testid="action-edit"
      data-toggle="modal"
      onClick={() => {
        handleAction && handleAction(tableItem);
      }}
      role={"button"}
    >
      <FontAwesomeIcon
        id="clickableAwesomeFont"
        data-toggle="tooltip"
        title="Edit"
        icon={faEdit}
        className="mx-2"
      />
    </span>
  );
}

export function SaveAction({ tableItem, handleAction }) {
  return (
    <span
      data-testid="action-save"
      data-toggle="modal"
      onClick={() => handleAction && handleAction(tableItem)}
      role={"button"}
    >
      <FontAwesomeIcon
        id="clickableAwesomeFont"
        data-toggle="tooltip"
        title="Save"
        icon={faCheck}
        color={"green"}
        className="mx-2"
      />
    </span>
  );
}

export function AddNewAction({ teableItem, handleAction }) {
  return (
    <span
      data-testid="action-add-new"
      data-toggle="modal"
      onClick={() => {
        handleAction && handleAction(teableItem);
      }}
      role={"button"}
    >
      <FontAwesomeIcon
        id="clickableAwesomeFont"
        data-toggle="tooltip"
        title="AddNew"
        icon={faPlusCircle}
        color={"green"}
        fontSize={20}
        className="mx-2"
      />
    </span>
  );
}
